import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    TimeInput,
    Input,
    DatePicker,
    Textarea,
    Select,
    SelectItem,
} from "@nextui-org/react";
import "./ModelForm.css";

const ReloadForm = () => {
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        navigate("/admin/reload");
    };

    return (
        <div className="main-inner-wrapper leavemenu-wrapper">

            <div className="px-4">
                <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
                    <h1 className="incident-report-heading ">Add Reload Details</h1>
                    <div className="form-container mt-8">
                        <form onSubmit={handleSubmit}>
                            <div>
                                <div className="form-row">
                                    <Select
                                        label="Year"
                                        className="max-w-full"
                                        variant="bordered"
                                    >
                                        <SelectItem key="one" value="one">
                                            1st
                                        </SelectItem>
                                        <SelectItem key="two" value="two">
                                            2nd
                                        </SelectItem>
                                        <SelectItem key="third" value="third">
                                            3rd
                                        </SelectItem>
                                        <SelectItem key="four" value="four">
                                            4th
                                        </SelectItem>
                                    </Select>

                                    <Select
                                        label="Department"
                                        className="max-w-full"
                                        variant="bordered"
                                    >
                                        <SelectItem key="cse" value="cse">
                                            CSE
                                        </SelectItem>
                                        <SelectItem key="it" value="it">
                                            IT
                                        </SelectItem>
                                        <SelectItem key="mech" value="mech">
                                            MECH
                                        </SelectItem>
                                        <SelectItem key="ece" value="ece">
                                            ECE
                                        </SelectItem>
                                        <SelectItem key="eee" value="eee">
                                            EEE
                                        </SelectItem>
                                        <SelectItem key="aids" value="aids">
                                            AIDS
                                        </SelectItem>
                                    </Select>

                                </div>

                                <div className="form-row">
                                    <Input
                                        variant="bordered"
                                        label="Student Id"
                                    />
                                    <Select
                                        label="Student Name"
                                        className="max-w-full"
                                        variant="bordered"
                                    >
                                        <SelectItem key="one" value="one">
                                            Siva kumar
                                        </SelectItem>
                                        <SelectItem key="two" value="two">
                                            Devaraj
                                        </SelectItem>
                                        <SelectItem key="third" value="third">
                                            Akash
                                        </SelectItem>
                                        <SelectItem key="four" value="four">
                                            Dhanajayan
                                        </SelectItem>
                                    </Select>

                                </div>
                                <div className="form-row">
                                    {/* <Input
                                        variant="bordered"
                                        label="Student Id"
                                    /> */}
                                    <Select
                                        label="Select Amount"
                                        className="max-w-full"
                                        variant="bordered"
                                    >
                                        <SelectItem key="five" value="five">
                                            5,000
                                        </SelectItem>
                                        <SelectItem key="ten" value="ten">
                                            10,000
                                        </SelectItem>
                                        <SelectItem key="fifteen" value="fifteen">
                                            15,000
                                        </SelectItem>
                                        <SelectItem key="twenty" value="twenty">
                                            20,000
                                        </SelectItem>
                                        <SelectItem key="twentyfive" value="twentyfive">
                                            25,000
                                        </SelectItem>
                                        <SelectItem key="thirty" value="thirty">
                                            30,000
                                        </SelectItem>
                                        <SelectItem key="thirtyfive" value="thirtyfive">
                                            35,000
                                        </SelectItem>
                                        <SelectItem key="fourty" value="fourty">
                                            40,000
                                        </SelectItem>
                                        <SelectItem key="fourtyfive" value="fourtyfive">
                                            45,000
                                        </SelectItem>
                                        <SelectItem key="fifty" value="fifty">
                                            50,000
                                        </SelectItem>
                                    </Select>

                                </div>

                                <div className="flex justify-center items-center gap-4" >
                                    <Button className="incidentSubmitBtn" type="submit">
                                        Submit
                                    </Button>
                                    <Button color="danger" variant="flat" onClick={() => navigate('/admin/reload')}>
                                        Cancel
                                    </Button>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReloadForm;
